<template>
  <BreadCrumbDetail :PageTitle="t('breadCrumb.collectedPaymentsBy')" />
  <LeadsContentByCompany/>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumbDetail from "../../components/Common/BreadCrumbDetail.vue";
import LeadsContentByCompany from "../../components/CRM/Leads/LeadsContentByCompany.vue";
import { useI18n } from "vue-i18n";

export default defineComponent(
  {
    name: "LeadsByCompanyPage",
    components: {
      BreadCrumbDetail,
      LeadsContentByCompany,
    },
    setup() {
      const { t } = useI18n();
      return {
      t,
    };
    }
  }
);
</script>